module.exports = __webpack_public_path__ + "static/media/06kakaotalk.0e829a0e.png";